export interface TickerProps {
	className?: string
	style?: React.CSSProperties
	position?: 'top' | 'bottom'
	duration?: number
	children: React.ReactNode
}
